import React, { Component, PropTypes } from 'react';
import LongRecruitName from './LongRecruitName';
import cx from 'classnames';
import _ from 'underscore';
import { ShortFieldValue } from './layout/FieldValue';

const Item = ({ className, children, ...rest }) => {
  return (
    <div
      style={{ display: 'inline-flex' }}
      className={cx('text-nowrap mg-left-xs mg-right-xs align-items-center', className)} {...rest}
    >
      {children}
    </div>
  );
};

export default class ShortRecruitDetails extends Component {
  static propTypes = {
    onClickName: PropTypes.func,
    recruit: PropTypes.shape({}).isRequired
  };

  static defaultProps = {
    onClickName: null
  };

  handleRecruitNameClick = () => {
    const { onClickName, recruit } = this.props;
    onClickName(recruit);
  };

  render() {
    const { className, onClickName, recruit, ...rest } = this.props;
    const { year, fieldValues, numNotes, phoneNumber } = recruit;

    const groupedByThree = _.chain([
      year ? [ <Item key="year">{year}</Item> ] : null,
      _.chain(fieldValues)
        .groupBy(({ field: { id } }) => id)
        .mapObject(values =>
          _.map(_.sortBy(values, 'order'), value => (
            <Item key={value.id}>
              <ShortFieldValue value={value}/>
            </Item>
          ))
        )
        .values()
        .flatten()
        .value(),
      phoneNumber ? [ <Item key="phone">{phoneNumber}</Item> ] : null,
      [ <Item key="numNotes">Notes: {numNotes}</Item> ]
    ]).compact()
      .flatten(true)
      .groupBy((child, ix) => Math.floor(ix / 3))
      .values()
      .value();

    return (
      <section {...rest} className={cx('color-black', className)}>
        {
          onClickName ?
            <a onClick={this.handleRecruitNameClick} className="h4 mg-none text-nowrap">
              <LongRecruitName bold={true} className="color-rich-orange lg-font" recruit={recruit}/>
            </a>
            :
            <h4 className="mg-none text-nowrap">
              <LongRecruitName bold={true} className="color-rich-orange lg-font" recruit={recruit}/>
            </h4>
        }
        {
          _.map(
            groupedByThree,
            (group, i) => (
              <div
                key={i}
                className="display-flex flex-direction-row align-items-center justify-content-space-between mg-top-sm"
              >
                { group }
              </div>
            )
          )
        }
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/ShortRecruitDetails.jsx